import type { Configuration, SingleRecordResponse } from '~/types'

export const useConfigurationApi = () => {
  const search = (params: MaybeRef<Configuration.SearchRequest> = {}) => {
    return useApiGet<SingleRecordResponse<Configuration.Model>>('/configuration', { params: unref(params) })
  }
  return { search }
}
